import BuyerDashboardView from "@/views/buyer/dashboard/DashboardView";
import MyAccountView from "@/views/MyAccountView";

export default [
  {
    name: "pages.buyer.dashboard",
    path: "dashboard",
    component: BuyerDashboardView
  },
  {
    name: "pages.buyer.my-account",
    path: "my-account",
    component: MyAccountView
  }
  
];
